import { Filmomtale } from "@filmweb/sanity-types";
import classNames from "classnames";
import SSectionHeader from "components/framework/SSectionHeader";
import { IListExtLink, ITextList } from "lib/types/Frontpage";
import { DocumentType_MOVIE, getUrl, ICultureArticle, IFileArticle, IMovieArticle, INewsArticle } from "lib/types/sanity";
import Link from "next/link";
import { CSSProperties } from "react";
import styles from "./TextListContainer.module.css";

//#region [Props]
type TextListContainerProps = {
    textLists: ITextList[];
    movies?: Filmomtale[];
};
//#endregion

//#region [Component]
export default function TextListContainer({ textLists, movies }: TextListContainerProps) {
    const style = { "--listcount": textLists.length };
    return (<section className={styles.STextListContainer}>
        {textLists.map(list => <TextList className={styles.STextListLayout} style={style as CSSProperties} key={list._key} textList={list} movies={movies} />)}
    </section>);
}
//#endregion

//#region [Props]
type TextListProps = {
    textList: ITextList;
    className?: string;
    movies?: Filmomtale[];
    style?: CSSProperties;
};

//#endregion
//#region [Component]
function TextList({ textList, className, movies, style }: TextListProps) {
    const listItems = textList?.listItems?.filter(li => !!(li?._id || li?._key));
    if ((listItems?.length ?? 0) === 0) {
        return null;
    }

    return <section className={classNames(styles.STextList, className)} style={style}>
        <SSectionHeader className={styles.STextListTitle}>{textList.listTitle}</SSectionHeader>
        <ol className={styles.SList}>
            {listItems.map(item => {
                let movie: Filmomtale | undefined;
                if (item._type === DocumentType_MOVIE) {
                    const filmItem = item as IMovieArticle;
                    movie = movies?.find(m => m.mainVersionEDI === filmItem.edi.current);
                }
                return <TextListItem key={(item._id ?? item._key) as string} item={item} movie={movie} />;
            })}

        </ol>
    </section>
}

type TextListItemProps = {
    item: ICultureArticle | IMovieArticle | INewsArticle | IFileArticle | IListExtLink;
    movie?: Filmomtale;
}

function TextListItem({ item, movie }: TextListItemProps) {
    const url = getUrl(item);
    if (!url) {
        console.warn("No url for", item);
        return null;
    }

    let title = movie?.title ?? item.title;
    if ('titleOverride' in item && item.titleOverride) {
        title = item.titleOverride as string;
    }

    return (<li>
        <Link href={url}>
            {title}
        </Link>
    </li>);
}
//#endregion